// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/app" + chunkId + "" + "5296fb1abb8c" + ".css";
};